"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var SfilterUpdateAction;
(function (SfilterUpdateAction) {
    SfilterUpdateAction.FILTER_UPDATE = 'FILTER_UPDATE';
    SfilterUpdateAction.FILTER_UPDATE_NOW = 'FILTER_UPDATE_NOW';
    SfilterUpdateAction.filterUpdate = typesafe_actions_1.createAction(SfilterUpdateAction.FILTER_UPDATE, function (resolve) { return function () {
        return resolve();
    }; });
    SfilterUpdateAction.filterUpdateNow = typesafe_actions_1.createAction(SfilterUpdateAction.FILTER_UPDATE_NOW, function (resolve) { return function () { return resolve(); }; });
})(SfilterUpdateAction || (SfilterUpdateAction = {}));
exports.default = SfilterUpdateAction;
